import { configureStore } from '@reduxjs/toolkit'
import SeoReducer from './SeoSlice';

const CommanStore = configureStore({
  reducer: {
    seoDetails: SeoReducer
  },
})

export default CommanStore;